/* jshint ignore:start */
export function tafelgastenSliders()
{
    let expert_slider = $('.expert-slider');
    if (expert_slider.length > 0) {
        expert_slider.each(function () {
            $(this).slick({
                infinite: true,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 3,
                dots: false,
                variableWidth: true,
                arrows: true,
                responsive: [{
                    breakpoint: 1024,
                    settings: { slidesToShow: 2 },
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    },
                }],
            });
        });
    }

    let session_slider = $('.session-slider');
    if (session_slider.length > 0) {
        session_slider.each(function () {
          // let session_slider_items = $(this).find('.session-container-item');
            $(this).slick({
                infinite: false,
                centerMode: false,
                slidesToShow: 2,
                dots: false,
                variableWidth: true,
              // arrows: session_slider_items.length < 3 ? false : true,
                arrows: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        centerMode: true,
                        slidesToShow: 1,
                    },
                }],
            });
        });
    }

    let reviews_slider = $('.reviews-slider');
    if (reviews_slider.length > 0) {
        reviews_slider.each(function () {
            $(this).slick({
                infinite: false,
                centerMode: false,
                slidesToShow: 3,
                dots: false,
                variableWidth: true,
                arrows: true,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        centerMode: true,
                        slidesToShow: 2,
                    },
                }, {
                    breakpoint: 768,
                    settings: {
                        centerMode: true,
                        slidesToShow: 1,
                    },
                }],
            });
        });
    }

    let session_single = $('.session-single-slider');
    if (session_single.length > 0) {
        session_single.slick({
            infinite: false,
            centerMode: false,
            slidesToShow: 1,
            dots: false,
            arrows: true,
            asNavFor: '.session-preview-slider',
        });
    }

    let preview_single = $('.session-preview-slider');
    if (preview_single.length > 0) {
        preview_single.slick({
            infinite: false,
            centerMode: false,
            adaptiveHeight: true,
            slidesToShow: 2,
            focusOnSelect: true,
            asNavFor: '.session-single-slider',
            dots: false,
            arrows: true,
        });
    }

    let populair_training_slider = $('.session-slider-alt');
    if (populair_training_slider.length > 0) {
        populair_training_slider.each(function () {
            const slidesPerView = $(this).data('slides');
            $(this).slick({
                infinite: false,
                centerMode: false,
                slidesToShow: slidesPerView || 2,
                focusOnSelect: true,
                dots: false,
                arrows: true,
                prevArrow: $(this).parent().find('.left'),
                nextArrow: $(this).parent().find('.right'),
                responsive: [
                {
                    breakpoint: 1139,
                    arrows: false,
                    settings: 'unslick',
                },
                ],
            });
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js